module.exports = __webpack_public_path__ + "img/product_1.f5df94e3.svg";